import {
  Toast
} from 'vant'
import axios from 'axios'

const URL = {
  development: 'http://zzfx.ie/v1',
  production: 'https://api.aieverybody.com/v1'
}

// 去除loading
const loadingHide = function (fn) {
  setTimeout(() => {
    Toast.clear();
    fn && fn();
  }, 1000);
};

const httpSuccess = function (response) {
  loadingHide(function () {
    if (response.data) {
      if (response.data.code !== 1) {
        Toast(response.data.message)
      }
    }
  });
};

const httpError = function (error) {
  const msg = error.message;
  loadingHide(function () {
    Toast(msg)
  });
};

// 每个请求的拦截器方法可能不一样
class AjaxRequest {
  constructor() {
    this.baseURL = process.env.NODE_ENV === 'development' ? URL.development : URL.production;
    this.timeout = 5000;
  }

  request(config) { // 用户请求设置的方法
    const instance = axios.create({
      baseURL: this.baseURL,
      timeout: this.timeout,
    });

    // 设置拦截器
    instance.interceptors.request.use((config) => {
      return config;
    }, (err) => {
      return Promise.reject(err);
    });

    // 设置响应拦截器
    instance.interceptors.response.use((res) => {
      httpSuccess(res);
      return res.data;
    }, (err) => {
      httpError(err)
      return Promise.reject(err);
    });

    return instance(config);
  }
}

export default new AjaxRequest();
